module.exports = __webpack_public_path__ + "static/media/track-should-have-known-better.42352d3b.png";